__webpack_require__.p = "https://webusstatic.yo-star.com/bluearchive-jp/ba-jp-dj-h5/prod/bajpdjh5/ba-dj/";